import { baseQuery } from '../baseQuery';

export const getSkillSets = async () => {
  const { data } = await baseQuery('skill-sets');

  return data;
};
